import styled from "styled-components";

export const CreatePage = styled.div`
  width: 100%;
  min-width: 0;
  padding: 16px;
  background: #f8fafc;

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const CreateHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 1040px;
  margin: 0 auto 24px;

  .ant-typography {
    margin: 0;
  }
`;

export const FormPanel = styled.div`
  min-width: 0;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
`;

export const FormCard = styled.div`
  padding: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const StepHeading = styled.div`
  margin-bottom: 20px;

  h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    line-height: 28px;
  }

  p {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 13px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 480px) {
    flex-wrap: wrap;

    > * {
      flex: 1 1 auto;
    }
  }
`;

export const ReviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`;

export const ReviewItem = styled.div`
  min-width: 0;
  padding: 12px;
  border: 1px solid #eef0f2;
  border-radius: 4px;
  background: #fafafa;

  ${({ $full }) => ($full ? "grid-column: 1 / -1;" : "")}

  dt {
    margin-bottom: 4px;
    color: #6b7280;
    font-size: 12px;
  }

  dd {
    margin: 0;
    color: #111827;
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }

  @media (max-width: 600px) {
    grid-column: 1 / -1;
  }
`;
